export const GASubscribe = (email) => {
  const dataLayer = window.dataLayer || []
  dataLayer.push({
    event: "subscribeEmail",
    userEmail: email,
  })
}
